export default "__VITE_ASSET__B97$liNF__"